import { Injectable } from '@angular/core';
import { HttpParamsService } from './http-params.service';
import { environment } from '../../environments/environment';
import { HttpClient, HttpParams } from '@angular/common/http';
import { NamedResponse } from '../models/response-models/named-response.model';
import { UserPermissions } from '../models/shared.model';
import { Observable } from 'rxjs';
import { UserRolesModel } from '../models/baseUser.model';
import { Apps } from '../enums/enum';
import { PaginatedWorklistResponse } from '../../modules/work-management/features/worklist/models/worklist.models';

@Injectable({
  providedIn: 'root'
})
export class SharedUserApiService {
  private readonly USER_BASE: string = `${environment.inventoryApiUrl}/Users`;
  private inventoryApiUrl = environment.inventoryApiUrl;
  private companyApiUrl: string = environment.companyApiUrl;
  private readonly GET_BY_USER = (userId: number): string =>
    `${this.USER_BASE}/${userId}/Worklists`;
  constructor(
    private http: HttpClient,
    private httpParamsService: HttpParamsService,
  ) {}

  getUsersLite(companyId: number) {
    const url = `${this.inventoryApiUrl}/Users?CompanyId=${companyId}`;
    return this.http.get<NamedResponse[]>(url);
  }

  getUserLiteById(id: number) {
    const url = `${this.companyApiUrl}/Users/${id}/Lite`;
    return this.http.get(url);
  }

  getPermissionsByUserId(userId: number) {
    const url = `${this.companyApiUrl}/Users/${userId}/Roles`;
    return this.http.get<UserPermissions[]>(url);
  }

  getWorklistsByUser(
    userId: number,
    queryParams: Record<string, any>,
  ): Observable<PaginatedWorklistResponse> {
    const params: HttpParams = this.httpParamsService.buildCleanHttpParams(queryParams);
    return this.http.get<PaginatedWorklistResponse>(this.GET_BY_USER(userId), { params });
  }

  getUserRoleDetails(userId: number): Observable<UserRolesModel[]> {
    const url = `${this.companyApiUrl}/Users/${userId}/Roles?Apps=${Apps.IMS}`;
    return this.http.get<UserRolesModel[]>(url);
  }

  setDefaultWarehouse(
    userId: number,
    warehouseId: number,
    appId: number,
    isDefault: boolean,
    warehouseLocationId?: number,
  ) {
    const url = `${this.companyApiUrl}/Users/${userId}/Warehouses/${warehouseId}/Default`;
    return this.http.put(url, {
      app: appId,
      isDefault: isDefault,
      listerDefaultWarehouseLocationId: warehouseLocationId,
    });
  }
}
